// extracted by mini-css-extract-plugin
export var body = "_c2-5";
export var closeButton = "_c2-f";
export var container = "_c2-1";
export var content = "_c2-2";
export var cta = "_c2-c";
export var ctaLabel = "_c2-b";
export var eyebrow = "_c2-3";
export var howTo = "_c2-6";
export var image = "_c2-e";
export var modal = "_c2-0";
export var socialButton = "_c2-d";
export var stepCard = "_c2-8";
export var stepLabel = "_c2-a";
export var stepNumber = "_c2-9";
export var steps = "_c2-7";
export var title = "_c2-4";